import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Patientss from './components/Patientss';

const patientss = (props,{ t }) => (
  <Container>
    <Patientss {...props} />
  </Container>
);

patientss.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(patientss);
